import { ApiHandler } from '@eshop/api-client'

import i18n from './i18n'

import { ServiceProduct } from '#/global/service/Product'

import { Config } from '#/global/helper/Config'
import { MessageFlash } from '#/global/helper/MessageFlash'

import type { AddToCart, AddToCartAfter } from '#/global/types'

/**
 * @todo přesunout do @eshop/api-client
 */
interface ApiErrorList {
    errors: {
        code: string
        message: string
        path: string
    }[]
}

const addToCart = (event: CustomEvent<AddToCart>) => {
    const payload = event.detail

    const api = new ApiHandler({
        path: '/cart/add-to-cart',
        method: 'POST',
        body: payload,
    })

    const getCodeFromPath = (path: string) => {
        // eslint-disable-next-line unicorn/better-regex
        const match = path.match(/productEshopList\[(\d+)\]/)
        const code = match ? payload.productEshopList[Number.parseInt(match[1])].code : null
        return code
    }

    const getProductList = async () => {
        // získání všech produktů, které se mají přidat do košíku
        const codes = payload.productEshopList.map(product => product.code)
        const productList = await ServiceProduct.getProductEshopByCode(codes, ['detail', 'price', 'brand', 'availability', 'unit', 'related', 'season'])

        return productList
    }

    api
        .addResponseHandler('2xx', async () => {
            const productList = await getProductList()

            // vytvoření seznamu produktů, které se mají přidat do košíku
            const afterList: AddToCartAfter['productEshopList'] = []
            for (const addToCartProduct of payload.productEshopList) {
                const code = addToCartProduct.code
                const product = productList.find(p => p?.code === code)

                if (product) {
                    afterList.push({
                        ...addToCartProduct,
                        product,
                        isSuccess: true,
                    })
                }
            }

            // vytvoření eventu s produkty, které se přidaly do košíku
            window.dispatchEvent(new CustomEvent<AddToCartAfter>('ES_ADD_TO_CART_AFTER', { detail: {
                productEshopList: afterList,
            } }))
        })
        .addResponseHandler('4xx', async () => {
            const body = await api.getData<ApiErrorList>(true)

            const productList = await getProductList()

            const t = i18n[Config.getLang()]

            for (const error of body?.errors ?? []) {
                const productCode = getCodeFromPath(error.path) ?? ''
                const product = productList.find(product => product?.code === productCode)

                switch (error.code) {
                    case '2':
                        MessageFlash.addError(t.errors.quantityMinimum(product?.detail.title ?? productCode))
                        break
                    case '6':
                        MessageFlash.addError(t.errors.notExisted(product?.detail.title ?? productCode))
                        break
                    case '9':
                        MessageFlash.addError(t.errors.quantityOutOfRange(product?.detail.title ?? productCode))
                        break
                    case '10':
                        MessageFlash.addError(t.errors.quantityMinimum(product?.detail.title ?? productCode))
                        break
                    default:
                        if (error.message && error.message !== '') {
                            // Zobrazíme chybu z api
                            MessageFlash.addError(`${error.message} (${product?.detail.title ?? productCode})`)
                        } else {
                            // Zobrazíme obecnou chybu
                            MessageFlash.addError(`${t.errors.default(error.code)} (${product?.detail.title ?? productCode})`)
                        }
                        break
                }
            }
        })

    api.send().catch((error) => {
        console.error('[GlobalListener-AddToCart]:', error)
    })
}

export default addToCart
